import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import {
	Col,
	ControlLabel,
	FormControl,
	FormGroup,
	InputGroup,
	Button,
	Modal
} from 'react-bootstrap';
import { Form } from 'axway-react-ui';

class FlowInfoDialog extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.onChangeName = this.onChangeName.bind(this);
		this.onChangeDescription = this.onChangeDescription.bind(this);
		this.onOkay = this.onOkay.bind(this);

		this.state = {
			name: this.props.name,
			description: this.props.description
		};
	}

	onChangeName(ev) {
		this.setState({
			name: ev.target.value
		});
	}

	onChangeDescription(ev) {
		this.setState({
			description: ev.target.value
		});
	}

	onOkay() {
		const name = this.state.name.trim();
		if (!name) {
			return;
		}
		const info = {
			name,
			description: this.state.description.trim()
		};
		this.setState(info);
		this.props.onOkay(info);
	}

	render() {
		const { show, onClose } = this.props;
		const { name, description } = this.state;

		const nameValid = !!name.trim();
		return (
			<Modal show={show} >
				<Modal.Header>
					<Modal.Title>
						{this.intl.formatMsg('Edit flow details')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form horizontal onSubmit={this.onOkay}>
						<FormGroup
							controlId="nameCtrl"
							validationState={!nameValid ? 'error' : null}
						>
							<Col componentClass={ControlLabel} sm={3}>
								{this.intl.formatMsg('Flow name')}:
							</Col>
							<Col sm={9}>
								<InputGroup>
									<FormControl
										autoFocus
										type="text"
										autoComplete="off"
										autoCorrect="off"
										spellCheck="off"
										onChange={this.onChangeName}
										value={name}
									/>
									<InputGroup.Addon>*</InputGroup.Addon>
								</InputGroup>
							</Col>
						</FormGroup>

						<FormGroup controlId="descriptionCtrl" className="flow-description-group">
							<Col componentClass={ControlLabel} sm={3}>
								{this.intl.formatMsg('Description')}:
							</Col>
							<Col sm={9}>
								<FormControl
									type="text"
									onChange={this.onChangeDescription}
									value={description || ''}
								/>
							</Col>
						</FormGroup>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					<Button
						bsSize="large"
						bsStyle="link"
						className="cancel"
						onClick={onClose}
					>
						{this.intl.formatMsg('Close')}
					</Button>
					<Button
						bsStyle="primary"
						bsSize="large"
						disabled={!nameValid}
						onClick={this.onOkay}
					>
						{this.intl.formatMsg('Update details')}
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

FlowInfoDialog.propTypes = {
	name: PropTypes.string.isRequired,
	description: PropTypes.string,
	onClose: PropTypes.func.isRequired,
	onOkay: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired
};

FlowInfoDialog.defaultProps = {
	description: ''
};

export default injectIntl(FlowInfoDialog);
